import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack, mergeStyles } from '@bingads-webui-react/fabric-control';

const redemptionStepStyles = mergeStyles({
  width: 252,
});

const iconStyles = mergeStyles({
  height: 100,
  marginBottom: 20,
});

const stepStyles = mergeStyles({
  fontWeight: 'bold',
});

export const RedemptionStep = ({
  stepNumber, icon, description, i18n,
}) => (
  <Stack className={classNames('coupon-step-block', redemptionStepStyles)}>
    <Stack horizontalAlign="center">
      <img
        className={classNames('coupon-step-block-icon', iconStyles)}
        alt=""
        src={icon}
      />
    </Stack>
    <span className="coupon-step-block-description">
      <span className={classNames('coupon-step-block-number', stepStyles)}>
        {i18n.getString('Coupon_LightboxStepNumberNew', { stepNumber })}
      </span> {description}
    </span>
  </Stack>
);

RedemptionStep.propTypes = {
  description: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  icon: PropTypes.node.isRequired,
  stepNumber: PropTypes.number.isRequired,
};
